import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const BANG_KE_PHIEU_XUAT_TRA_NCC_COLUMNS: ExcelColumnMapping[] = [
  {
    header: 'Đơn vị',
    width: 14,
    resolver: row => row.unit_id ?? ''
  },
  {
    header: 'Ngày c/từ',
    width: 14,
    resolver: row => formatDate(row.ngay_ct ?? '')
  },
  {
    header: 'Số c/từ',
    width: 16,
    resolver: row => row.so_ct ?? ''
  },
  {
    header: 'Mã NCC',
    width: 12,
    resolver: row => row.ma_kh ?? ''
  },
  {
    header: 'Tên NCC',
    width: 24,
    resolver: row => row.ten_kh ?? ''
  },
  {
    header: 'Diễn giải',
    width: 24,
    resolver: row => row.dien_giai ?? ''
  },
  {
    header: 'Mã vật tư',
    width: 14,
    resolver: row => row.ma_vt ?? ''
  },
  {
    header: 'Tên vật tư',
    width: 24,
    resolver: row => row.ten_vt ?? ''
  },
  {
    header: 'ĐVT',
    width: 10,
    resolver: row => row.dvt ?? ''
  },
  {
    header: 'Số lượng',
    width: 14,
    resolver: row => Number(row.sl_xuat ?? 0)
  },
  {
    header: 'Giá',
    width: 14,
    resolver: row => Number(row.gia ?? 0)
  },
  {
    header: 'Tiền hàng',
    width: 16,
    resolver: row => Number(row.tien_xuat ?? 0)
  },
  {
    header: 'Thuế',
    width: 14,
    resolver: row => Number(row.thue ?? 0)
  },
  {
    header: 'TK nợ',
    width: 14,
    resolver: row => row.tk_du ?? ''
  },
  {
    header: 'Mã kho',
    width: 14,
    resolver: row => row.ma_kho ?? ''
  },
  {
    header: 'Bộ phận',
    width: 14,
    resolver: row => row.ma_bp ?? ''
  },
  {
    header: 'Vụ việc',
    width: 14,
    resolver: row => row.ma_vv ?? ''
  },
  {
    header: 'Hợp đồng',
    width: 14,
    resolver: row => row.ma_hd ?? ''
  },
  {
    header: 'Đợt thanh toán',
    width: 16,
    resolver: row => row.ma_dtt ?? ''
  },
  {
    header: 'Khế ước',
    width: 14,
    resolver: row => row.ma_ku ?? ''
  },
  {
    header: 'Phí',
    width: 12,
    resolver: row => row.ma_phi ?? ''
  },
  {
    header: 'Sản phẩm',
    width: 14,
    resolver: row => row.ma_sp ?? ''
  },
  {
    header: 'Lệnh sản xuất',
    width: 16,
    resolver: row => row.ma_lsx ?? ''
  },
  {
    header: 'C/p không h/lệ',
    width: 18,
    resolver: row => row.ma_cp0 ?? ''
  },
  {
    header: 'Mã c/từ',
    width: 14,
    resolver: row => row.ma_ct ?? ''
  }
];
